import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { updateFormField } from 'store/forms/actions';
import { submitRegister } from 'store/forms/actions';
import { FormField, UploadWithoutCreds } from 'components';
import { formFields1, formFields2 } from './formFields';
import { omit, isEmpty } from 'lodash';
import { registerDocs } from './registerDocs';
import { isRegisterFormValid } from 'utils';
import { SuccessModal, InvalidModal } from 'components/layout/components';
import dayjs from 'dayjs';

const RegisterPage = () => {
  const [form] = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isVisible, setVisible] = useState(false);
  const [isVisibleError, setVisibleError] = useState(false);
  const error = useSelector(state => state.forms?.error);
  const register = useSelector(state => state.forms?.register);
  const documents = useSelector(state => state.forms?.documents);

  useEffect(() => {
    if (!isEmpty(error)) setVisibleError(true);
  }, [error]);

  const handleChange = ({ key, type, event }) => {
    let newValue;

    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      // newValue = new Date(event).toLocaleDateString('en-US');
      newValue = dayjs(event).format('YYYY-MM-DD');
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals'
    ) {
      newValue = event;
    } else if (type === 'businessSize') {
      newValue = event.event;
    }

    dispatch(
      updateFormField({
        group: 'register',
        key,
        value: newValue,
      })
    );
  };

  const submitCall = () => {
    const payload = {
      firstName: register?.firstName,
      lastName: register?.lastName,
      companyVat: register?.companyVat,
      companyName: register?.companyName,
      companySize: register?.companySize,
      foundingDate: register?.foundingDate,
      email: register?.email,
      phone: register?.phone,
      text: register?.text,
      gemiRepresentationCertificateContentItemId: documents?.certGemi?.id,
      aadeBusinessRegistryContentItemId: documents?.registAade?.id,
      solemnDeclarationContentItemId: documents?.respStatement?.id,
    };

    dispatch(
      submitRegister(payload, navigate, check => {
        // console.log(check);
        setVisible(!check);
      })
    );
  };

  const handleSubmit = async e => {
    e.preventDefault();
    submitCall();
  };

  return (
    <>
      <SuccessModal
        isVisible={isVisible}
        setVisible={setVisible}
        title={'Επιτυχής Υποβολή!'}
        message={'Η δήλωση ενδιαφέροντος καταχωρήθκε επιτυχώς.'}
        returnButtonTitle={'Επιστροφή στην Αρχική'}
        returnButtonNavigate={'/loginAs'}
      />
      <InvalidModal
        isVisible={isVisibleError}
        setVisible={setVisibleError}
        error={error}
        returnButtonTitle={'Επιστροφή στην Αρχική'}
        returnButtonNavigate={'/loginAs'}
      />
      <div className="main-wrapper register-page-wrapper">
        <div className="register-page-card">
          <div
            id="register-page-card-title"
            className="register-page-card-title"
          >
            Δήλωση Ενδιαφέροντος
          </div>
          <div
            id="register-page-card-description"
            className="register-page-card-description"
          >
            Συμπλήρωσε την παρακάτω φόρμα και ένας εξειδικευμένος εκπρόσωπος της
            Grant Thornton θα έρθει σε επικοινωνία μαζί σου.
          </div>

          <div className="mt-2">
            <Form form={form} trigger="onChange" className="register-page">
              <div
                className="carrier-data-form register"
                style={{ width: '47%', display: 'inline-block' }}
              >
                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  // className="carrier-data-form__row"
                >
                  {formFields1.map((field, index) => {
                    return (
                      <Col
                        key={index}
                        className={`gutter-row ${
                          field.name === 'firstName' ||
                          field.name === 'lastName' ||
                          field.name === 'foundingDate' ||
                          field.name === 'phone'
                            ? 'specific-col'
                            : ''
                        }`}
                        span={field.span}
                      >
                        <Form.Item
                          name={[field.name]}
                          rules={field.rules}
                          validateFirst
                        >
                          <FormField
                            key={index}
                            disabled={field?.disabled}
                            {...omit(field, [
                              'span',
                              'rules',
                              'offset',
                              'disabled',
                            ])}
                            onChange={value =>
                              handleChange({
                                key: field.name,
                                type: field.type,
                                event: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    );
                  })}
                </Row>
              </div>
              <div
                className="carrier-data-form"
                style={{
                  width: '47%',
                  display: 'inline-block',
                  marginLeft: '4%',
                }}
              >
                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  // className="carrier-data-form__row"
                  className="register-subject-form"
                >
                  {formFields2.map((field, index) => {
                    return (
                      <Col key={index} className="gutter-row" span={field.span}>
                        <Form.Item
                          name={[field.name]}
                          rules={field.rules}
                          validateFirst
                        >
                          <FormField
                            key={index}
                            disabled={field?.disabled}
                            {...omit(field, [
                              'span',
                              'rules',
                              'offset',
                              'disabled',
                            ])}
                            onChange={value =>
                              handleChange({
                                key: field.name,
                                type: field.type,
                                event: value,
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    );
                  })}
                </Row>
              </div>
              <div className={'register-docs-container mt-2'}>
                {registerDocs().map((item, index) => (
                  <UploadWithoutCreds
                    item={item}
                    subFileCode={item.fileCode}
                    key={index}
                    path={'forms'}
                    group={'documents'}
                  />
                ))}
              </div>
              <div className="register-buttons mt-2">
                <Button
                  className="return-button mt-3"
                  type="secondary"
                  disabled={false}
                  onClick={() => navigate('/loginAs')}
                >
                  Επιστροφή στην Αρχική
                </Button>
                <Button
                  type="primary"
                  className="submit-login mt-3"
                  disabled={!isRegisterFormValid(register, documents)}
                  onClick={handleSubmit}
                  id="inputEnter"
                >
                  Υποβολή Φόρμας
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterPage;
